<mat-dialog-content data-test="DeactivateMessage">{{ 'UI.Common.Message.DeactivateGuard' | translate }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" data-test="DeactivateCancelButton" [mat-dialog-close]="false">
    {{ 'UI.Common.Action.Cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" data-test="DeactivateOkButton" [mat-dialog-close]="true">
    {{ 'UI.Common.Action.DeactivateGuardOk' | translate }}
  </button>
</mat-dialog-actions>
